<template>
    <header class="header">
      <div class="header-container">
        <!-- Logo/Brand -->
        <div class="logo">
          <h1 class="hero-title">
            <img src="../assets/images/gotcha.png" class="logo-icon" />
          </h1>
        </div>
  
        <!-- Navigation -->
        <nav class="nav">
          <div class="nav-left">
            <button
              v-for="item in navItems"
              :key="item.id"
              @click="scrollToSection(item.id)"
              class="nav-button"
              :class="{ active: activeSection === item.id }"
            >
              {{ item.label }}
            </button>
          </div>
          <div class="nav-right">
            <button @click="handleButtonSettings" class="nav-button settings-button">
              {{ user ? (user.is_subscribed ? 'Settings' : 'Subscribe') : 'Login' }}
            </button>
            <button v-if="user" @click="handleLogout" class="nav-button settings-button yellow">
              LOGOUT
            </button>
          </div>
        </nav>
  
        <!-- Mobile menu button -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
  
      <!-- Mobile Navigation -->
      <nav class="mobile-nav" :class="{ open: mobileMenuOpen }">
        <button :disabled="loadingStore.isLoading"
          v-for="item in navItems"
          :key="item.id"
          @click="scrollToSection(item.id)"
          class="mobile-nav-button"
        >
          {{ item.label }}
        </button>
        <!-- Settings and Logout buttons in mobile nav -->
        <!-- <button :disabled="loadingStore.isLoading" class="mobile-nav-button settings-button">
          ROADMAP
        </button> -->
        <button :disabled="loadingStore.isLoading" @click="handleButtonSettings" class="mobile-nav-button settings-button">
          {{ user && !user.is_subscribed ? 'Subscribe' : 'Settings' }}
        </button>
        <button :disabled="loadingStore.isLoading" v-if="user" @click="handleLogout" class="mobile-nav-button settings-button yellow">
          LOGOUT
        </button>

      </nav>
    </header>
  </template>
  
<script lang="ts" setup>

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router';
import User from '@/types/User';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/auth';
import { useUserStore } from '@/stores/user';
import { useLoadingStore } from '../stores/loading'


const loadingStore = useLoadingStore()
const router = useRouter();
const authStore = useAuthStore();
const userStore = useUserStore();
const mobileMenuOpen = ref(false)
const activeSection = ref('')
const props = defineProps<{ user: User | null }>();

const navItems = computed(() => {
  const galleryItem = props.user
    ? { id: 'prompts', label: 'PROMPTS' }
    : { id: 'gallery', label: 'EXAMPLES' }

    if (userStore.user) {
  return [
    { id: 'works', label: 'HOW TO' },
    galleryItem,
    { id: 'prices', label: 'PRICING' },
    { id: 'contact', label: 'CONTACT' },
  ]
  } else {
    return [
          { id: 'works', label: 'HOW TO' },
    { id: 'demo', label: "WATCH DEMO"},
    galleryItem,
    { id: 'prices', label: 'PRICING' },
    { id: 'contact', label: 'CONTACT' },

    ]
  }
})

// const scrollToSection = (sectionId?: string) => {
// const element = document.querySelector(`.${sectionId}`)
// if (element) {
//     element.scrollIntoView({
//     behavior: 'smooth',
//     block: 'start',
//     })
// } else {
//     router.push("/pricing")
// }
// mobileMenuOpen.value = false
// }

const scrollToSection = (sectionId?: string) => {
  if (sectionId === 'prices') {
    router.push("/pricing")
  } else if (sectionId) {
    const element = document.querySelector(`.${sectionId}`)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    } 
  }
  mobileMenuOpen.value = false
}

const toggleMobileMenu = () => {
mobileMenuOpen.value = !mobileMenuOpen.value
}

const handleButtonSettings = () => {
    if (props.user?.email) {
        router.push('/settings')
    } else {
        router.push('/home')
    }
    mobileMenuOpen.value = false
};

const handleLogout = async () => {
            await supabase.auth.signOut();
            authStore.setSession(null);
            userStore.clearUser();
            router.push('/')
            mobileMenuOpen.value = false
};

</script>
  
  <style scoped>
  .header {
    background: white;
    border-bottom: 2px solid #f0f0f0;
  }
  
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1px;
    gap: 1rem;
    width: 100%;
  }
  
  .logo h1 {
    margin: 0;
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1;
  }
  
  .logo-icon {
    width: 4rem;
    height: 4rem;
    margin-right: 0.5rem;
    vertical-align: middle;
    object-fit: contain;
  }
  
  .hero-title {
    color: black;
  }
  
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    margin: 0 2rem;
  }

  .nav-left {
    display: flex;
    gap: 0.5rem;
  }

  .nav-right {
    display: flex;
    gap: 0.5rem;
  }
  
  .nav-button {
    background: none;
    border: 3px solid transparent;
    font-size: 0.8rem;
    font-weight: 800;
    color: #64748b;
    cursor: pointer;
    padding: 0.2rem 0.5rem;
    border-radius: 10px;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .nav-button.settings-button {
    border: 3px solid #A1E3F9;
    font-weight: 600;
    padding: 0.6rem 1.2rem;
    background-color: #A1E3F9;
    margin-left: 5px;
  }

  .nav-button.settings-button:hover {
    border-color: #42a8b4;
    background-color: #42a8b4;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .nav-button.settings-button.yellow {
    background-color: #ffd700;
    border-color: #ffd700;
  }

  .nav-button.settings-button.yellow:hover {
    background-color: #ffcd00;
    border-color: #ffcd00;
  }
  
  .nav-button:hover {
    border-color: #578FCA;
    background-color: #578FCA;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .nav-button.active {
    background-color: #8EB486;
    border-color: #8EB486;
    color: white;
  }
  
  /* Mobile Menu */
  .mobile-menu-btn {
    display: none;
    flex-direction: column;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    gap: 4px;
    margin-left: auto;
  }
  
  .mobile-menu-btn span {
    width: 25px;
    height: 3px;
    background: #333;
    transition: 0.3s;
    border-radius: 2px;
  }
  
  .mobile-nav {
    display: none;
    flex-direction: column;
    background: white;
    padding: 1rem 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    border-radius: 0 0 15px 15px;
  }
  
  .mobile-nav.open {
    max-height: 400px;
  }
  
  .mobile-nav-button {
    background: none;
    border: 3px solid transparent;
    padding: 1rem 1rem;
    text-align: left;
    font-size: 1rem;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    border-radius: 10px;
    margin: 2px;
  }
  
  .mobile-nav-button:hover {
    border-color: #42a8b4;
    background-color: #42a8b4;
    color: white;
  }

  .mobile-nav-button.settings-button {
    border: 3px solid #A1E3F9;
    background-color: #A1E3F9;
    color: #64748b;
  }

  .mobile-nav-button.settings-button:hover {
    border-color: #42a8b4;
    background-color: #42a8b4;
    color: white;
  }

  .mobile-nav-button.settings-button.yellow {
    background-color: #ffd700;
    border-color: #ffd700;
  }

  .mobile-nav-button.settings-button.yellow:hover {
    background-color: #ffcd00;
    border-color: #ffcd00;
  }
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .nav {
      display: none;
    }
    
    .mobile-menu-btn {
      display: flex;
      margin-right: 30px;
    }
    
    .mobile-nav {
      display: flex;
    }
    
    .header-container {
      gap: 1rem;
    }
    
    .logo h1 {
      font-size: 1.5rem;
    }
  }
  
  @media (max-width: 480px) {
    .header-container {
      padding: 0.5rem 1rem;
      gap: 0.5rem;
    }
    
    .logo h1 {
      font-size: 1.3rem;
    }

    .logo-icon {
      width: 4rem;
      height: 4rem;
    }
  }
  </style>